<template>
  <div>
    <v-row class="weathermap-container-map">
      <v-col cols="12" style="position: relative">
        <div :id="index" ref="map" class="map"></div>
        <div cols="12" class="pa-0 slider-timeline">
          <v-slider
            v-model="selectedTs"
            ticks="always"
            v-if="times.length"
            :step="getTimesSteps"
            thumb-label="always"
            :min="times[0]"
            :max="times[times.length - 1]"
          >
          <template v-slot:thumb-label="{value}">
              {{moment(value).format('DD/MM HH:mm')}}
          </template>
          </v-slider>
        </div>
        <!-- <v-slider
          type="range"
          min="1"
          max="24"
          step="1"
          ticks="always"
          v-model="current.t"
        >
          <template v-slot:thumb-label>
            {{ currentTime }}
          </template>
        </v-slider> -->
      </v-col>

      <v-col elevation="5" class="map-navigator" cols="12">
        <v-card-text v-if="isOpen" class="mx-0 pr-0">
          <v-list-item v-if="$parent.user.admin == 1">
            <span>
              <label for="debug">
                <input type="checkbox" id="debug" v-model="current.debug" />
                <span class="fzs" :class="{ op05: !current.debug }"
                  >debug mode</span
                >
              </label>
            </span>
          </v-list-item>
          <template v-for="(group, key) in nav">
            <div
              :key="`nav_${key}`"
              class="mapnav-item mb-3"
              :id="'nav_' + key"
            >
              <b>{{ group.name }}</b>
              <template v-for="(child, e) in group.child">
                <div
                  v-if="params[child]"
                  :key="`child${e}`"
                  :class="{ unready: !params[child].isReady }"
                >
                  <template v-if="params[child].isSelected">
                    <input
                      type="checkbox"
                      :value="true"
                      @click="hideLayer(child)"
                    />
                    <span class="error--text" v-if="params[child].isError"
                      >Aucune donnée disponible</span
                    >
                    <span v-else v-html="params[child].name" />

                    <span
                      v-if="params[child].isSelected"
                      @click="$event.stopPropagation()"
                    >
                    </span>
                  </template>
                  <!-- <span v-else @click="">
                    <i v-if="params[child].isReady" class="fa fa-square-o"></i
                    >{{ " " }}
                    <span v-html="params[child].name"></span>
                  </span> -->
                  <template v-else>
                    <input
                      type="checkbox"
                      :value="false"
                      @click="showLayer(child)"
                    /><span v-html="params[child].name" />
                  </template>
                </div>
              </template>
            </div>
          </template>
        </v-card-text>
      </v-col>

      <v-col cols="12">
        <v-col class="py-0 my-0" v-show="false">
          <span>
            <label class="fzs op05">{{ $t("weathermap.map.date") }}</label>
            <v-text-field
              filled
              dense
              type="date"
              v-model="current.datetime"
              :value="current.datetime"
              ref="pikaday"
            />
          </span>
        </v-col>
        <v-col class="py-0 my-0">
          <span>
            <label class="fzs op05">{{ $t("weathermap.map.model") }}</label>
            <v-select
              filled
              dense
              color="white"
              :items="models"
              v-model="current.model"
              item-value="param"
              item-text="name"
            />
            <!-- <select v-model="current.model">
            <option :value="model.param" v-for="(model, x) in models" :key="`model${x}`">
              {{ model.name }}
            </option>
          </select> -->
          </span>
        </v-col>
        <v-col class="py-0 my-0" v-show="false">
          <span>
            <label class="fzs op05"
              >{{ $t("weathermap.map.run") }} :
              <small
                >{{ currentModelInfo.runs ? currentModelInfo.runs.length : 0 }}
                {{ $t("weathermap.map.dispo") }}.</small
              ></label
            >
            <v-select
              filled
              dense
              color="white"
              v-model="current.run"
              :items="currentModelInfo.runs"
              item-value=""
              item-text="run"
            />
            <!-- <select v-model="current.run">
            <option v-for="(run, i) in currentModelInfo.runs" :value="parseInt(run)" :key="i">
              {{ run }}
            </option>
          </select> -->
          </span>
        </v-col>
      </v-col>
    </v-row>

    <div
      id="tooltip"
      :style="'top:' + tooltip.y + 'px; left:' + tooltip.x + 'px;'"
      :class="{ active: tooltip.show == true }"
    >
      <span v-html="tooltip.html"></span>
    </div>

    <div class="range_bars">
      <template v-for="(param, b) in params">
        <div
          class="range_bar"
          :key="`param${b}`"
          v-if="param.isSelected && param.rangeBars"
        >
          <template v-for="(rangeBar, key) in param.rangeBars">
            <div class="range_bar-param" :key="`key${key}`" v-if="rangeBar">
              <div class="range_bar-head">
                <span>{{ key }}</span>
              </div>
              <div
                class="range_bar-color"
                v-for="(bar, c) in rangeBar"
                :key="`bar${c}`"
              >
                <span class="value">{{ bar.value }}</span>
                <span
                  class="color"
                  :style="
                    'background:' + bar.color + '; opacity:' + bar.alpha + ';'
                  "
                ></span>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>

    <div class="map-btn map-ui" v-if="false">
      <button @click="addMap" v-if="$parent.maps.length < 2">
        <i class="fa fa-columns"></i>
      </button>
      <button @click="removeMap" v-if="id != 0 && $parent.maps.length > 1">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import _ from "lodash";
import moment from "moment";
import VueHorizontalTimelineSlider from "@/components/VueHorizontalTimelineSlider.vue";

import L from "leaflet";
import { LControl } from "vue2-leaflet";
import * as chroma from "chroma-js";
import Vue from "vue";
import * as canvasGridLayer from "./canvasGridLayer";
import * as canvasParticules from "./canvasParticules";
import axios from "axios";
import "@/assets/draw-image-clipper";
export default {
  components: {
    LControl,
    VueHorizontalTimelineSlider,
  },
  data: function () {
    return {
      selectedTs: null,
      panIsOpen: false,
      map: {},
      swipeDirection: "None",
      animTime: false,
      slr_mkr: [],
      moment:moment,
      index: moment().unix() + Math.round(Math.random() * 100),
      models: {},
      params: {},
      isOpen: false,
      current: {
        debug: false,
        bounds: {},
        datetime: moment().format("YYYY-MM-DD"),
        globalAlpha: 0.6,
        model: "",
        run: 0,
        t: 1,
        paramsList: [],
      },
      tooltip: {
        show: false,
        x: 0,
        y: 0,
        html: null,
      },
      nav: {
        temp: {
          name: "Température",
          child: ["test", "temp_surface", "temp_air"],
        },
        wind: {
          name: "Vent",
          child: ["wind_velocity", "wind", "wind_arrow", "wind_gust"],
        },
        cloud: {
          name: "Nébulosité",
          child: [
            "cloud_coverage_low",
            "cloud_coverage_med",
            "cloud_coverage_high",
          ],
        },
        precip: {
          name: "Précipitation",
          child: ["rain", "snow", "graupel", "refc"],
        },
        storm: {
          name: "Instabilité",
          child: ["iso0", "iso268K", "iso263K", "cape", "cin", "lftx"],
        },
      },
      tickLabels: [],
    };
  },
  props: ["center", "zoom", "id"],
  watch: {
    selectedTs() {
      let times = this.times;
      this.current.t = times.findIndex((map) => map == this.selectedTs);
    },
    "$parent.mapState": {
      deep: true,
      handler: function () {
        if (
          this.$parent.mapState.sync &&
          this.$parent.mapState.from != this.index
        ) {
          this.tooltipSet({
            x: this.$parent.mapState.mouseX,
            y: this.$parent.mapState.mouseY,
            lat: this.$parent.mapState.mouseLat,
            lng: this.$parent.mapState.mouseLng,
          });
          if (
            this.$parent.mapState.center.lat &&
            this.$parent.mapState.center.lng
          )
            this.map.setView(
              this.$parent.mapState.center,
              this.$parent.mapState.zoom
            );
          this.current.t = this.$parent.mapState.t;
          this.current.run = this.$parent.mapState.run;
          this.current.datetime = this.$parent.mapState.datetime;
        }
      },
    },
    "current.model": function () {
      this.current.run = parseInt(_.last(this.currentModelInfo.runs));
      this.initLayers();
    },
    "current.datetime": function () {
      var self = this;
      this.getRuns(function (runs) {
        _.each(self.models, function (model, i) {
          model.runs = runs[model.param] || [];
        });
        self.current.run = parseInt(_.last(self.currentModelInfo.runs));
      });
    },
    current: {
      deep: true,
      handler: function () {
        var self = this;
        _.each(this.params, function (param, key) {
          if (param.layer && param.isSelected) {
            param.layer.setOptions({
              debug: self.current.debug,
              bounds: self.current.bounds,
              imgUri: self.getImgUrl(param),
            });
          }
        });
        if (
          this.$parent.mapState.sync &&
          this.$parent.mapState.from == this.index
        ) {
          this.$parent.mapState.t = this.current.t;
          this.$parent.mapState.datetime = this.current.datetime;
        }
      },
    },
  },
  computed: {
    getTimesSteps() {
      if (!this.times.length) return;
      let steps = this.times[1] - this.times[0];
      return steps;
    },
    times() {
      let times = [];
      for (var i = 0; i < 24; i++) {
        let time = moment().set({ hour: this.current.run, minute: 0 });
        times.push(moment(time).add(i, "hours").unix() * 1000);
      }
      // times = times.reverse();
      return times;
    },
    currentModelInfo: function () {
      var m = _.find(this.models, { param: this.current.model });
      return m || {};
    },
    currentTime: function () {
      var time =
        1 * this.current.run +
        1 * this.current.t +
        1 * (moment().utcOffset() / 60);
      var day = Math.floor(time / 24);
      return (
        moment(this.current.datetime).add(day, "d").format("ddd DD MMM") +
        " " +
        (time - 24 * day) +
        ":00"
      );
    },
  },
  methods: {
    swipe(direction) {
      this.swipeDirection = direction;
      if (direction == "Left") {
        this.panIsOpen = true;
      } else {
        this.panIsOpen = false;
      }
    },
    addMarker: function (latlng) {
      var self = this;
      var marker = L.marker(latlng);
      var circle = L.circle(latlng, {
        radius: 30 * 1000,
        fill: false,
        weight: 1,
      });
      marker.on("click", function () {
        marker.remove();
        circle.remove();
        self.removeMarker(latlng);
      });
      circle.on("click", function () {
        marker.remove();
        circle.remove();
        self.removeMarker(latlng);
      });
      marker.addTo(this.map);
      circle.addTo(this.map);
      if (!_.find(this.slr_mkr, { lat: latlng.lat, lng: latlng.lng }))
        this.slr_mkr.push(latlng);
      window.localStorage.setItem("slr_mkr", JSON.stringify(this.slr_mkr));
    },
    removeMarker: function (latlng) {
      var self = this;
      _.each(this.slr_mkr, function (o, i) {
        if (o && o.lat == latlng.lat && o.lng == latlng.lng)
          self.slr_mkr.splice(i);
        window.localStorage.setItem("slr_mkr", JSON.stringify(self.slr_mkr));
      });
    },
    animTimePlay: function () {
      if (this.current.t >= 24) this.current.t = 0;
      this.current.t = 1 * this.current.t + 1;
      this.animTime = setTimeout(this.animTimePlay, 1000);
    },
    animTimeStop: function () {
      clearTimeout(this.animTime);
      this.animTime = false;
    },
    initLayers: function () {
      var self = this;
      // get params by model
      this.getParamByModel(function (params) {
        self.current.paramsList = params;

        // get bounds then range's param and create layers
        self.getBoundsRaster(function (bounds) {
          Vue.set(self.current, "bounds", bounds);

          // get param scale
          self.getParamRange(function (ranges) {
            _.each(self.params, function (param, key) {
              param.range = {};

              // set scale
              _.each(param.paramUrl, function (key) {
                if (self.current.paramsList.indexOf(key) < 0) return;
                param.isReady = true;
                param.range[key] = ranges[key] ? ranges[key] : {};
              });

              // create range bar
              self.createRangeBars(param, function (rangeBars) {
                param.rangeBars = rangeBars;
              });

              // update or remove layer
              if (_.isEmpty(param.range)) {
                param.isSelected = false;
                param.isLoaded = false;
                param.isReady = false;
                param.isError = false;
                if (param.layer) param.layer.remove();
              } else if (param.isSelected) {
                self.updateLayer(param);
              }
            });
          });
        });
      });
    },
    updateLayer: function (param) {
      var self = this;
      param.layer.setOptions({
        debug: self.current.debug,
        bounds: self.current.bounds,
        imgUri: self.getImgUrl(param),
      });
    },
    createLayer: function (param) {
      param.isLoading = true;
      switch (param.type) {
        case "particule":
          param.layer = L.Layer.canvasParticules({
            param: param,
            zIndex: param.zIndex,
            debug: this.current.debug,
            bounds: this.current.bounds,
            globalAlpha: this.current.globalAlpha,
            imgUri: this.getImgUrl(param),
            onReady: function () {
              param.isLoading = false;
              param.isLoaded = true;
            },
          });
          break;
        case "raster":
        default:
          param.layer = L.gridLayer.canvasGridLayer({
            param: param,
            zIndex: param.zIndex,
            debug: this.current.debug,
            bounds: this.current.bounds,
            globalAlpha: this.current.globalAlpha,
            imgUri: this.getImgUrl(param),
            crs: L.CRS.EPSG3857,
            onReady: function () {
              param.isLoading = false;
              param.isLoaded = true;
            },
          });
          param.layer.setZIndex(param.zIndex);
          break;
      }
    },
    createRangeBars: function (param, callback) {
      var self = this;
      var rangeBars = {};
      var seg = param.rangeSeg || 10;
      if (!_.isEmpty(param.range) && param.type == "raster" && param.colors) {
        _.each(param.range, function (range, paramUrl) {
          rangeBars[paramUrl] = [];
          var stepRange = (range.srcmax - range.srcmin) / seg;
          var colors = chroma.scale(param.colors).colors(seg + 1);
          _.each(colors, function (color, i) {
            rangeBars[paramUrl][i] = {};
            rangeBars[paramUrl][i].color = color;
            rangeBars[paramUrl][i].alpha =
              i == 0 && param.noZero ? 0 : param.dynAlpha ? (1 / seg) * i : 1;
            rangeBars[paramUrl][i].value = Math.floor(
              (stepRange * i + range.srcmin) *
                (self.$parent.units[paramUrl].coef || 1)
            );
          });
        });
      }
      if (callback) callback(rangeBars);
      else return rangeBars;
    },
    countLayerSelected: function (keyNav) {
      var self = this;
      var count = 0;
      _.each(this.nav[keyNav].child, function (keyParam) {
        count +=
          self.params[keyParam] && self.params[keyParam].isSelected ? 1 : 0;
      });
      return count;
    },
    countLayerError: function (keyNav) {
      var self = this;
      var count = 0;
      _.each(this.nav[keyNav].child, function (keyParam) {
        count += self.params[keyParam] && self.params[keyParam].isError ? 1 : 0;
      });
      return count;
    },
    getBoundsRaster: function (callback) {
      var self = this;
      var xhr = new XMLHttpRequest();
      //   http://api.layers.previmeteo.net/layers/fr/arome0p025/bounds
      xhr.open(
        "GET",
        "https://api-layers.previmeteo.net/layers/fr/" +
          this.current.model +
          "/bounds",
        true
      );
      xhr.onload = function (e) {
        if (this.status != 200) return;
        var data = JSON.parse(this.response);
        var bounds = {
          max: { x: data.maxLon, y: data.maxLat },
          min: { x: data.minLon, y: data.minLat },
        };
        callback(bounds);
      };
      xhr.send();
    },
    // getParamByModel: function (callback) {
    async getParamByModel(callback) {
      // var self = this;
      console.log(this.current.model);
      this.current.t = 11;
      if(this.current.model == "") return;
      console.log(`https://api-layers.previmeteo.net/layers/fr/${this.current.model}/params`);
      try {
        const { data } = await axios.get(
          `https://api-layers.previmeteo.net/layers/fr/${this.current.model}/params`
        );
        callback(data);
      } catch (err) {
        console.log("err", err);
      }

      // try {
      // var xhr = new XMLHttpRequest();
      // // http://api.layers.previmeteo.net/layers/fr/arome0p025/params
      //   xhr.open(
      //     "GET",
      //     "https://api-layers.previmeteo.net/layers/fr/" +
      //       this.current.model +
      //       "/params",
      //     true
      //   );
      //   xhr.onload = function (e) {
      //     if (this.status != 200) return;
      //     var data = JSON.parse(this.response);
      //     callback(data);
      //   };
      //   xhr.send();
      // } catch (err) {
      //   console.log('there an error');
      //   console.log(err);
      // }
    },
    getParamRange: function (callback) {
      var self = this;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", "https://api-layers.previmeteo.net/layers/scales", true);
      xhr.onload = function (e) {
        if (this.status != 200) return;
        var data = JSON.parse(this.response);
        callback(data);
      };
      xhr.send();
    },
    getRuns: function (callback) {
      var self = this;
      var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        "https://api-layers.previmeteo.net/layers/fr/" + this.current.datetime,
        true
      );
      xhr.onload = function (e) {
        if (this.status != 200) return;
        var data = JSON.parse(this.response);
        callback(data);
      };
      xhr.send();
    },
    getImgUrl: function (param) {
      var self = this;
      var imgUri = {};
      //   http://api.layers.previmeteo.net/layer/fr/gfs0p25/2021-07-20/6/1/windd
      _.each(param.paramUrl, function (paramUrl, key) {
        imgUri[
          paramUrl
        ] = `https://api-layers.previmeteo.net/layer/fr/${self.current.model}/${self.current.datetime}/${self.current.run}/${self.current.t}/${paramUrl}`;
      });
      return imgUri;
    },
    addMap: function () {
      if (this.$parent.maps.length < 2) this.$parent.maps.push("v-map");
    },
    removeMap: function () {
      if (this.$parent.maps.length > 1) this.$parent.maps.splice(this.id, 1);
    },
    showLayer: function (key) {
      if (!this.params[key].isReady) return;
      this.params[key].isSelected = true;
      if (!this.params[key].layer) this.createLayer(this.params[key]);
      this.params[key].layer.setOptions({
        debug: this.current.debug,
        bounds: this.current.bounds,
        imgUri: this.getImgUrl(this.params[key]),
      });
      this.params[key].layer.addTo(this.map);
    },
    hideLayer: function (key) {
      if (!this.params[key].layer) return;
      this.params[key].layer.removeFrom(this.map);
      this.params[key].isSelected = false;
    },
    tooltipSet: function (opt) {
      var self = this;
      var html =
        "<small>lat: " +
        opt.lat.toFixed(2) +
        " lng: " +
        opt.lng.toFixed(2) +
        "</small><br>";
      var values = {};
      var count = 0;

      // get value for each layer selected
      _.each(self.params, function (param) {
        if (!param.isSelected || !param.layer || !param.layer.getValueAt)
          return;
        values = _.merge(
          values,
          param.layer.getValueAt({ lat: opt.lat, lng: opt.lng })
        );
        count++;
      });

      // check if values isn't empty
      if (!count) return;

      // convert values into html
      _.each(values, function (value, param) {
        html +=
          " <small>" +
          self.$parent.units[param].name +
          " : </small> " +
          Math.round(value * (self.$parent.units[param].coef || 1) * 10) / 10 +
          " <small>" +
          self.$parent.units[param].unit +
          "</small><br>";
      });

      this.tooltip.x = opt.x || 0;
      this.tooltip.y = opt.y || 0;
      this.tooltip.html = html || null;
      this.tooltip.show = html ? true : false;
      if (this.tooltip.timer) clearTimeout(this.tooltip.timer);
      this.tooltip.timer = setTimeout(function () {
        self.tooltip.show = false;
      }, 3000);
    },
    saveParams: function () {
      var savedParams = {};
      _.each(this.params, function (param, name) {
        savedParams[name] = {};
        _.each(param, function (val, key) {
          if (["globalAlpha"].indexOf(key) > -1) savedParams[name][key] = val;
        });
      });
      window.localStorage.setItem("slr_prms", JSON.stringify(savedParams));
    },
    restoreParams: function () {
      var self = this;
      var savedParams = window.localStorage.getItem("slr_prms");
      if (savedParams) {
        _.each(JSON.parse(savedParams), function (param, name) {
          _.each(param, function (val, key) {
            self.params[name][key] = val;
          });
        });
      }
    },
  },
  destroyed: function () {
    if (this.map) this.map.remove();
  },
  mounted: function () {
    setTimeout(() => {
      this.current.model = "arome0p025";
    }, 100);

    if (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) {
      this.isOpen = true;
    } else {
      this.isOpen = true;
    }
    var self = this;

    // init raster params from localStorage or parent
    // Vue.set( this, 'params', JSON.parse(JSON.stringify(this.$parent.params)));
    this.params = JSON.parse(JSON.stringify(this.$parent.params));
    this.restoreParams();

    _.each(this.params, function (o, name) {
      self.$watch("params." + name + ".globalAlpha", function () {
        self.saveParams();
      });
    });

    // get model from parent
    Vue.set(this, "models", JSON.parse(JSON.stringify(this.$parent.models)));

    // init pikaday
    var picker = new Pikaday({
      field: this.$refs.pikaday,
      minDate: moment("2018-06-08").toDate(),
      maxDate: moment().toDate(),
      onSelect: function (date) {
        self.current.datetime = this.getMoment().format("YYYY-MM-DD");
      },
      i18n: {
        months: moment.localeData()._months,
        weekdays: moment.localeData()._weekdays,
        weekdaysShort: moment.localeData()._weekdaysShort,
      },
    });

    // get runs
    this.getRuns(function (runs) {
      if (runs.length == 0) {
        self.current.datetime = moment(self.current.datetime)
          .add(-1, "d")
          .format("YYYY-MM-DD");
      }
      _.each(self.models, function (model, i) {
        self.models[i].runs = runs[model.param] || [];
      });
      self.current.run = parseInt(_.last(self.currentModelInfo.runs));
    });

    // init layer
    var layer_default = L.tileLayer(
      "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        attribution: "",
        maxZoom: 18,
        zIndex: 1,
      }
    );

    var layer_dark = L.tileLayer(
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png",
      {
        attribution: "",
        maxZoom: 18,
        zIndex: 1,
      }
    );

    var layer_light = L.tileLayer(
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png",
      {
        attribution: "",
        maxZoom: 18,
        zIndex: 1,
      }
    );

    var layer_sat = L.tileLayer(
      "https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}@2x.jpg90?access_token={accessToken}",
      {
        attribution: "",
        maxZoom: 18,
        id: "mapbox.streets",
        zIndex: 1,
        accessToken:
          "pk.eyJ1IjoicG1jb20iLCJhIjoiY2lxajgxbHF3MDBjZWkwbWMza2pwYzFoayJ9.a1ywamqhc2BKAdxMdgcBpA",
      }
    );

    // init map
    this.map = L.map(this.$refs.map, {
      center: this.center || this.$parent.map.center,
      zoom: this.zoom || this.$parent.map.zoom,
      minZoom: 6,
      maxZoom: 12,
      zoomControl: false,
      zoomAnimation: false,
      fadeAnimation: false,
      scrollWheelZoom: true,
      layers: [layer_default],
    });

    this.map.on("zoom", function (e) {
      self.initLayers();
    });

    L.control
      .layers(
        {
          Classic: layer_default,
          Light: layer_light,
          Dark: layer_dark,
          Satellite: layer_sat,
        },
        {}
      )
      .addTo(this.map);

    // L.Control.Menu = L.Control.extend({
    //   onAdd: function () {
    //     return "<p>coucou</p>";
    //   },
    //   onRemove: function () {},
    // });

    // L.control.menu = function (opts) {
    //   return new L.Control.Menu(opts);
    // };

    // L.control.menu({ position: "topleft" }).addTo(this.map);

    var customLayer = L.geoJson(null, {
      zIndex: 10,
      style: function (feature) {
        return {
          opacity: 0.5,
          weight: 1,
          fillOpacity: 0,
          color: "#fff",
        };
      },
    });

    omnivore
      .kml("static/kml/departements-frances.kml", null, customLayer)
      .addTo(this.map);

    this.map.on("mousemove", function (e) {
      var x = e.containerPoint.x + 4;
      var y = e.containerPoint.y;
      var lng = e && e.latlng ? e.latlng.lng : 0;
      var lat = e && e.latlng ? e.latlng.lat : 0;

      if (self.$parent.mapState.from == self.index) {
        self.$parent.mapState.mouseX = x;
        self.$parent.mapState.mouseY = y;
        self.$parent.mapState.mouseLng = lng;
        self.$parent.mapState.mouseLat = lat;
      }

      self.tooltipSet({
        x: x,
        y: y,
        lat: lat,
        lng: lng,
      });
    });

    this.$el.addEventListener("mouseover", function (e) {
      self.$parent.mapState.from = self.index;
    });

    this.map.on("move", function (e) {
      if (self.$parent.mapState.from == self.index) {
        self.$parent.mapState.center = self.map.getCenter();
        self.$parent.mapState.zoom = self.map.getZoom();
      }
    });

    this.map.addEventListener("click", function (e) {
      //   self.addMarker(e.latlng);
    });

    L.control
      .zoom({
        position: "bottomright",
      })
      .addTo(this.map);

    L.control.scale().addTo(this.map);

    this.initLayers();

    // get local markers
    var slr_mkr = window.localStorage.getItem("slr_mkr");
    this.slr_mkr = slr_mkr ? JSON.parse(slr_mkr) : [];
    // add markers on map
    this.map.markers = [];
    _.each(this.slr_mkr, function (latlng, i) {
      //   self.addMarker(latlng);
    });

    // reselected this layer is preview maps is selected too
    if (self.$parent.maps.length > 1) {
      _.each(self.$parent.$children[self.id - 1].params, (param, key) => {
        if (param.isSelected) {
          setTimeout(() => {
            self.showLayer(key);
          }, 900);
        }
      });
    } else if (self.params["wind_velocity"]) {
      setTimeout(() => {
        // self.showLayer('wind_velocity')
      }, 900);
    }
    this.$nextTick(() => {
      this.map.invalidateSize(true);
    });
  },
};
</script>

<style lang="scss">
.weathermap-container-map {
  .map {
    border: none !important;
    height: 65vh;
    position: relative;
  }
  #weathermap
    > div
    > div
    > div.row
    > div.col
    > div.v-input.v-input--is-label-active.v-input--is-dirty.theme--light.v-input__slider
    > div
    > div.v-messages.theme--light {
    display: none;
  }
  #weathermap
    > div
    > div
    > div.row
    > div.col
    > div.v-input.v-input--is-label-active.v-input--is-dirty.theme--light.v-input__slider
    > div
    > div.v-input__slot {
    margin: 0;
    padding: 0;
  }
  #weathermap
    > div
    > div
    > div.row
    > div.col
    > div.v-input.v-input--is-label-active.v-input--is-dirty.theme--light.v-input__slider
    > div
    > div.v-input__slot
    > div {
    margin: 0;
    padding: 0;
  }
  #weathermap
    > div
    > div
    > div.row
    > div.col
    > div.v-input.v-input--is-label-active.v-input--is-dirty.theme--light.v-input__slider {
    position: absolute;
    width: 80%;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    bottom: 50px;
    z-index: 2;
  }

  .map-nav {
    // position:absolute;
    z-index: 100;
    max-height: 75vh;
    box-shadow: 1px 1px 4px rgb(0 0 0 / 20%);
    overflow: scroll;
  }

  .chevron-mobile {
    display: none;
  }

  .leaflet-control-zoom.leaflet-bar.leaflet-control {
    display: none;
  }


.map-navigator.col.col-12 {
  position: absolute;
  top: 1em;
  opacity: 0.4;
  right: 0;
  width: 20%;
  max-height: 60vh;
  overflow: scroll;
}

.map-navigator.col.col-12:hover {
  opacity: 1;
}

.mapnav-item {
  background-color: white;
  border: 1px solid #b6b6b6;
  border-radius: 10px;
  padding: 5px;
  font-size: 10px;
}

.slider-timeline {
  z-index: 2;
  bottom: 30px;
  width:100%;
  border-radius:10px;
  border: 1px solid #7c7c7c;
  box-shadow: 1px 1px 5px #58585847;
  background-color: #0d070378!important;

}
.v-input__slot {
    margin-bottom: 0px;
}

.v-messages.theme--light {
    display: none;
}

  @media screen and (max-width: 1280px) {
      .map-navigator.col.col-12 {
          width:40%;
      }
    .chevron-mobile {
      display: block;
      position: absolute;
      top: 50%;
    }

    /* Rédigez vos propriétés CSS ici */
    .map-nav {
      position: absolute;
      // display:none;
      background-color: white;
      border-radius: 20px 0px 0px 20px;
      right: -57vw;
      transition: right 0.3s ease;
      overflow-y: scroll;
      overflow-x: hidden;
    }
    .map-nav.open {
      right: 0vw;
      width: 80%;
      transition: right 0.3s ease;
    }
    .leaflet-control-layers.leaflet-control {
      display: none;
    }
  }
}

</style> 
